import { render, staticRenderFns } from "./purchaseShowPay.vue?vue&type=template&id=cf1cb4b2"
import script from "./purchaseShowPay.vue?vue&type=script&lang=js"
export * from "./purchaseShowPay.vue?vue&type=script&lang=js"
import style0 from "./purchaseShowPay.vue?vue&type=style&index=0&id=cf1cb4b2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports